(function () {
  const initProductAccordion = () => {
    $(".about__accordion-toggle")
      .off("click.accordion")
      .on("click.accordion", function () {
        const $toggle = $(this);
        const isOpen = $toggle.hasClass("active");
        $toggle.attr("aria-expanded", String(!isOpen));
        if (isOpen) {
          $toggle.removeClass("active");
          $toggle.siblings(".about__accordion-description").stop().slideUp(300);
        } else {
          $toggle.addClass("active");
          $toggle.siblings(".about__accordion-description").eq($toggle.index()).stop().slideDown(300);
        }
      });
  };
  document.addEventListener("shopify:section:load", function () {
    initProductAccordion();
  });
  initProductAccordion();
})();